import { Stack, Text } from '@fluentui/react';
import { TimeUser } from '../../../../../api/generated/data-contracts';
import { useMemo } from 'react';
import { useUserCapacity } from '../hooks/useUserCapacity';

type Props = {
    user: TimeUser;
};

export const UpdateUserCapacity = ({ user }: Props) => {
    const { activeCapacity, isDefault, isCalendar } = useUserCapacity(user);

    const renderDefaultOrCalendarState = useMemo(
        () => (
            <Stack horizontal verticalAlign="center">
                <Stack.Item grow>
                    <Text className="subGroupName textOverflow">{isCalendar ? `Calendar (${activeCapacity} hrs)` : `Default (${activeCapacity} hrs)`}</Text>
                </Stack.Item>
            </Stack>
        ),
        [activeCapacity, isCalendar],
    );

    const renderCustomState = useMemo(
        () => (
            <Stack horizontal verticalAlign="center">
                <Stack.Item grow>
                    <Text className="subGroupName textOverflow">{activeCapacity} hrs</Text>
                </Stack.Item>
            </Stack>
        ),
        [activeCapacity],
    );

    return (
        <Stack style={{ paddingLeft: 6, paddingRight: 12, width: '100%' }}>{isDefault || isCalendar ? renderDefaultOrCalendarState : renderCustomState}</Stack>
    );
};
